import { Component } from '@angular/core';

@Component({
  selector: 'app-small-page-layout',
  templateUrl: './small-page-layout.component.html',
  styleUrls: ['./small-page-layout.component.css']
})
export class SmallPageLayoutComponent {

}
